import { StartAllowance, CheckAllowance, SubmitAllowance, SubmitRedeem, WaitAllowance, WaitRedeem } from './components'

import { StopwatchIcon, FireWorkIcon, FireIcon } from 'primsell-shared-layer/assets/icons'
import { IconE, ModalDescriptionE, ModalTitleE, RedeemProgressStepI, RedeemStepsE } from 'types'

export const modalIconConfig: Record<IconE, JSX.Element> = {
  [IconE.STOPWATCH_ICON]: <StopwatchIcon style={{ width: 40, height: 60 }} />,
  [IconE.FIRE_ICON]: <FireIcon style={{ width: 40, height: 60 }} />,
  [IconE.FIRE_WORK_ICON]: <FireWorkIcon style={{ width: 40, height: 60 }} />,
}

export const modalTitleConfig: Record<ModalTitleE, string> = {
  [ModalTitleE.ACCESS]: 'Allowance access сonfirmation',
  [ModalTitleE.APPROVAL]: 'Transaction approval...',
  [ModalTitleE.BURN_NFT]: 'Burn this NFT in progress...',
  [ModalTitleE.NFT_BURNED]: 'NFT burned successfully',
}

export const modalDescriptionConfig: Record<ModalDescriptionE, string> = {
  [ModalDescriptionE.WAIT]: 'Wait, please',
  [ModalDescriptionE.CHECK_EMAIL]: 'Please check your email for brand guidance and unique redeem code.',
}

export const REDEEM_PROGRESS_STEPS: Record<RedeemStepsE, RedeemProgressStepI> = {
  [RedeemStepsE.START_ALLOWANCE]: {
    progress: 0,
    modalTitle: modalTitleConfig[ModalTitleE.ACCESS],
    description: modalDescriptionConfig[ModalDescriptionE.WAIT],
    icon: modalIconConfig[IconE.STOPWATCH_ICON],
    component: <StartAllowance />,
  },
  [RedeemStepsE.CHECK_ALLOWANCE]: {
    progress: 25,
    modalTitle: modalTitleConfig[ModalTitleE.ACCESS],
    description: modalDescriptionConfig[ModalDescriptionE.WAIT],
    icon: modalIconConfig[IconE.STOPWATCH_ICON],
    component: <CheckAllowance />,
  },
  [RedeemStepsE.SUBMIT_ALLOWANCE]: {
    progress: 25,
    modalTitle: modalTitleConfig[ModalTitleE.ACCESS],
    description: modalDescriptionConfig[ModalDescriptionE.WAIT],
    icon: modalIconConfig[IconE.STOPWATCH_ICON],
    component: <SubmitAllowance />,
  },
  [RedeemStepsE.WAIT_ALLOWANCE]: {
    progress: 50,
    modalTitle: modalTitleConfig[ModalTitleE.ACCESS],
    description: modalDescriptionConfig[ModalDescriptionE.WAIT],
    icon: modalIconConfig[IconE.STOPWATCH_ICON],
    component: <WaitAllowance />,
  },
  [RedeemStepsE.SUBMIT_REDEEM]: {
    progress: 75,
    modalTitle: modalTitleConfig[ModalTitleE.APPROVAL],
    description: modalDescriptionConfig[ModalDescriptionE.WAIT],
    icon: modalIconConfig[IconE.STOPWATCH_ICON],
    component: <SubmitRedeem />,
  },
  [RedeemStepsE.WAIT_REDEEM]: {
    progress: 95,
    modalTitle: modalTitleConfig[ModalTitleE.BURN_NFT],
    description: modalDescriptionConfig[ModalDescriptionE.WAIT],
    icon: modalIconConfig[IconE.FIRE_ICON],
    component: <WaitRedeem />,
  },
  [RedeemStepsE.BURN_IN_PROGRESS]: {
    progress: 100,
    modalTitle: modalTitleConfig[ModalTitleE.BURN_NFT],
    description: modalDescriptionConfig[ModalDescriptionE.WAIT],
    icon: modalIconConfig[IconE.FIRE_ICON],
  },
  [RedeemStepsE.NFT_BURNED]: {
    modalTitle: modalTitleConfig[ModalTitleE.NFT_BURNED],
    description: modalDescriptionConfig[ModalDescriptionE.CHECK_EMAIL],
    icon: modalIconConfig[IconE.FIRE_WORK_ICON],
  },
}
